import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table'
import { MoreHorizontal } from 'lucide-react'

import type { ConnectionRowPresentation } from './types'

interface ConnectionsTableProps {
	connectionRows: ConnectionRowPresentation[]
	onSelectConnection: (row: ConnectionRowPresentation) => void
	selectedConnectionId?: string
}

export function ConnectionsTable({
	connectionRows,
	onSelectConnection,
	selectedConnectionId,
}: ConnectionsTableProps) {
	return (
		<Table>
			<TableHeader className="border-t border-t-[#3A2E2F]/20 border-b border-b-[#3A2E2F] [&_tr]:!border-0">
				<TableRow>
					<TableHead>Platform</TableHead>
					<TableHead>Description</TableHead>
					<TableHead>Owner</TableHead>
					<TableHead>Status</TableHead>
					<TableHead className="w-[50px]"></TableHead>
				</TableRow>
			</TableHeader>
			<TableBody className="[&_tr:last-child]:!border-b [&_tr]:!border-t-0 [&_tr]:!border-l-0 [&_tr]:!border-r-0">
				{connectionRows.map((row) => (
					<TableRow
						key={row.id}
						className={`group cursor-pointer hover:bg-muted/50 !border-b !border-b-[#3A2E2F]/20 ${
							selectedConnectionId === row.id ? 'bg-muted' : ''
						}`}
						onClick={() => onSelectConnection(row)}
					>
						<TableCell className="font-medium">
							<div className="flex items-center gap-3">
								{row.logoSrc ? (
									<img src={row.logoSrc} alt={`${row.platform} logo`} className="h-5 w-5" />
								) : (
									<div className="h-5 w-5 rounded bg-muted flex items-center justify-center text-xs font-medium">
										{row.platform.charAt(0).toUpperCase()}
									</div>
								)}
								{row.platform}
							</div>
						</TableCell>
						<TableCell className="text-sm text-muted-foreground">{row.description || '—'}</TableCell>
						<TableCell className="capitalize">{row.owner}</TableCell>
						<TableCell>
							<Badge variant={row.status === 'active' ? 'default' : 'secondary'} className="capitalize">
								{row.status}
							</Badge>
						</TableCell>
						<TableCell>
							<DropdownMenu>
								<DropdownMenuTrigger asChild>
									<Button
										variant="ghost"
										size="icon"
										className="opacity-0 group-hover:opacity-100 transition-opacity"
										onClick={(e) => e.stopPropagation()}
										aria-label="Connection actions"
									>
										<MoreHorizontal className="h-4 w-4" />
									</Button>
								</DropdownMenuTrigger>
								<DropdownMenuContent align="end">
									{row.managed ? (
										<DropdownMenuItem>Connect Your Own</DropdownMenuItem>
									) : (
										<>
											<DropdownMenuItem>Edit</DropdownMenuItem>
											<DropdownMenuItem className="text-destructive">Delete</DropdownMenuItem>
										</>
									)}
								</DropdownMenuContent>
							</DropdownMenu>
						</TableCell>
					</TableRow>
				))}
			</TableBody>
		</Table>
	)
}


